import { render, staticRenderFns } from "./CategoriesMenu.vue?vue&type=template&id=18c60d2d&scoped=true&"
import script from "./CategoriesMenu.vue?vue&type=script&lang=js&"
export * from "./CategoriesMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesMenu.vue?vue&type=style&index=0&id=18c60d2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c60d2d",
  null
  
)

export default component.exports